<template>
  <div class="d-flex flex-column OverviewOrderView" style="min-height: auto !important">
    <TableTemplate
      class="OverviewOrderView"
      :value="sortedOrders"
      :skeleton-class="loading ? 'ske' : ''"

      :columns="tableColumns"
      :columnVariables="tableColumnVariables"
      :capitalize="capitalize"
      :page="page"
      :noMinHeight="true"

      @update-column-order="updateColumnOrder"
    >
      <template #above>
        <div class="card-title-wrapper d-flex justify-content-between">
          <h3 class="d-flex align-items-center card-title mr-2">
            <BackButton/>
            Order bekijken
          </h3>
          <div>
            <button class="btn btn-secondary">
              Print factuur
            </button>
          </div>
        </div>
        <OrderOverview v-bind="order || {}" :loading="loading" :orders="orders"/>

        <RightColumn
          v-model="remark"
          class="mobile-one"
          :loading="loading"
          :selected-order="order"
          @save="save(false)"
        />
      </template>

      <template #before-pagination>
        <PriceCalculationOverview v-if="!loading" v-bind="order" :orders="orders"/>
      </template>

      <template #cell-name="{ item }">
        <router-link class="name-wrapper" :to="`/admin/product/edit/${item.sku}`">
          <img v-if="orderImages[item.sku]" class="product-img" width="44" height="44" :src="orderImages[item.sku]">
          <span class="name">{{ item.name }}</span>
        </router-link>
      </template>

      <template #cell-qty="{ item }">
        <span class="qty-circle">{{ item.qty }}</span>
      </template>

      <template #cell-price="{ item }">
        <span>€ {{ item.price }}</span>
      </template>

      <template #right-column>
        <RightColumn
          v-model="remark"
          class="desktop-one"
          :loading="loading"
          :selected-order="order"
          @save="save(false)"
        />
      </template>

      <template #row-action="{item}">
        <div class="delete-icon" @click="removeProductOrder(item)">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
          </svg>
        </div>
      </template>

    </TableTemplate>
    <div class="mt-2">
      <button class="btn btn-primary" @click="openProductSelector">
        Product toevoegen
      </button>
    </div>
  </div>
</template>

<script>

import table from "src/mixins/table"

import OrderItem from "./OrderItem.vue"
import AddressForm from "../../components/OrderForms/AddressForm.vue"
import FormInput from "/src/components/Inputs/FormInput.vue"
import Carousel from "../../layout/Carousel.vue"
import GeneralDetails from "../../components/OrderForms/GeneralDetails.vue"
import OrderOverview from "@/components/OrderOverview/OrderOverview"
import RightColumn from "@/components/OrderOverview/RightColumn"
import PriceCalculationOverview from "@/components/OrderOverview/PriceCalculationOverview"
import BackButton from "@/components/BackButton"

import EmptyStatePlaceholder from "src/layout/EmptyStatePlaceholder.vue"
import TableTemplate from "@/layout/Table/TableTemplate"
import {constructManualSortingComputedProperty} from "@/utils/manualSort"

const placeholder = {
  name: "qui",
  price: "978.00",
  qty: 3,
  sku: "tempore",
}

const fields = [
  "site", "orderNumber", "orderDate", "language", "orders", "shipmentTrackAndTrace",
]

const addressFields = [
  "firstName", "lastName", "street", "houseNumber", "houseNumberExtension", "postalCode", "city", "countryCode", "telephone", "email",
]

const ORDER_SOURCE = 'tableOrder'

export default {
  mixins: [
    table({
      pageReference: "order-view-page",
      columnConfigurationId: "order-view-page",

      manualPagination: true,
      page_size: 50,
      orderSource: ORDER_SOURCE,
      defaultColumnSizes: {
        name: '540px',
      },
      columnTranslationMaps: {
        Naam: "name",
        Aantal: "qty",
        "Prijs p/s": "price",
        "Terugbetaald": "refunded",
      },
      defaultColumns: ["Naam", "Aantal", "Prijs p/s", "Terugbetaald"],
    })
  ],
  metaInfo() {
    const order = this.order

    return {
      title: order ? `${order.site} - Order` : "Order Informatie"
    }
  },
  components: {
    RightColumn,
    TableTemplate,
    AddressForm,
    PriceCalculationOverview,
    BackButton,
    OrderOverview,
    FormInput,
    GeneralDetails,
    OrderItem,
    EmptyStatePlaceholder,
    Carousel,
  },
  data() {
    return {
      state: null,
      order: null,
      loading: true,

      remark: '',

      orders: [],
      orderImages: {},
      placeholder,

      ...fields.reduce((obj, key) => ({
        ...obj,
        [key]: "",
      }), {}),

      shippingAddress: {
        ...addressFields.reduce((obj, key) => ({
          ...obj,
          [key]: "",
        }), {}),
      },
      invoiceAddress: {
        ...addressFields.reduce((obj, key) => ({
          ...obj,
          [key]: "",
        }), {}),
      },
    }
  },
  validations: {
    ...fields.reduce((obj, key) => ({
      ...obj,
      [key]: {},
    }), {}),

    shippingAddress: {
      ...addressFields.reduce((obj, key) => ({
        ...obj,
        [key]: {},
      }), {}),
    },
    invoiceAddress: {
      ...addressFields.reduce((obj, key) => ({
        ...obj,
        [key]: {},
      }), {}),
    },
  },
  async created() {
    this.load()
  },
  methods: {
    removeProductOrder(item) {
      const i = this.orders.findIndex(order => order.sku === item.sku)
      if (i > -1) this.orders.splice(i, 1)
    },

    openProductSelector() {
      this.$pushModal({
        modal: "ProductSelector",
        toBind: {
          title: "Add orders",
          callback: newProducts => {
            newProducts.forEach(prod => this.orderImages[prod.sku] = prod.src)
            this.orders = ([...this.orders, ...newProducts])
            this.orderImages = {...this.orderImages}
            this.save(false)
          },
        },
      })
    },
    goBack() {
      this.$router.push("/admin/overview-order").catch(()=>{})
    },
    async loadImages() {
      const orders = this.orders

      const orderImages = {}
      await Promise.all(
        orders.map(async ({ sku }) => {
          try {
            const results = (await this.axios.get(`/api/products/${sku}/files`)).data.results

            if (results && results[0]) {
              orderImages[sku] = results[0].url
            }
          } catch(e) {
            console.log('failed to download the files for the order line')
          }
        })
      )
      this.orderImages = orderImages
    },
    async load() {
      this.loading = true

      const order = (await this.axios.get(`/api/orders/${this.id}`)).data
      this.remark = order.remark
      console.log("fgk: order: ", order)
      if (order) {
        this.orders = order.orders
        await this.loadImages()
        this.state = order.state

        fields.forEach(key => this.$v[key].$model = order[key])
        addressFields.forEach(key => this.$v.shippingAddress[key].$model = order.shippingAddress[key])
        addressFields.forEach(key => this.$v.invoiceAddress[key].$model = order.invoiceAddress[key])
      }
      if (order.shipmentTrackAndTrace && order.shipmentTrackAndTrace.includes(';')) {
        order.shipmentTrackAndTrace = order.shipmentTrackAndTrace.split(';')
      }
      this.order = order

      this.loading = false
    },
    async removeOrder(index) {
      const orders = this.orders.slice()
      orders.splice(index, 1)

      await this.$handlePromise(async () => {
        await this.axios.put(`/api/orders/${this.id}`, {
          ...this.orderDetails,

          orders,
        })
        this.$store.dispatch('clearCacheSearch', "orders")

        this.$success("Een bestelling verwijderd!")
        await this.load()
      })
    },
    async save(shouldRedirect = true) {
      this.orders = this.orders.map(item => ({...item, price: parseFloat((item.price + '').replace(/,/g, '.'))}))
      await this.$handlePromise(async () => {
        await this.axios.put(`/api/orders/${this.id}`, {
          ...this.orderDetails,
          remark: this.remark,
        })
        this.$store.dispatch('clearCacheSearch', "orders")
        this.$success("Bestelling bijgewerkt!")

        shouldRedirect && this.$router.push("/admin/overview-order").catch(()=>{})
      })
    },
  },
  computed: {
    sortedOrders: constructManualSortingComputedProperty('orders', null, ORDER_SOURCE),
    orderDetails() {
      return {
        ...fields.reduce((obj, key) => ({
          ...obj,
          [key]: this.$v[key].$model,
        }), {}),

        shippingAddress: {
          ...addressFields.reduce((obj, key) => ({
            ...obj,
            [key]: this.$v.shippingAddress[key].$model,
          }), {}),
        },
        invoiceAddress: {
          ...addressFields.reduce((obj, key) => ({
            ...obj,
            [key]: this.$v.invoiceAddress[key].$model,
          }), {}),
        },
      }
    },

    id() {
      return this.$route.params.id
    },
    ordersWithImages() {
      const images = this.orderImages
      return this.orders.map(item => ({...item, src: images[item.sku]}))
    },
    disabled() {
      return this.state !== "NOT_SENT" && this.state !== "SENT_TO_POSTNL" && this.state !== "CANCELED"
    },
    placeholderList() {
      const p = this.placeholder
      return [p,p,p,p,p,p]
    },
  },
}

</script>

<style>

.images-wrapper .card-body {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
}

.OverviewOrderView .card-body {
  padding: 0px !important;
}

.OverviewOrderView .ComposableTable td {
  padding: 14px !important;
}

</style>

<style scoped>

.name-wrapper {
  position: relative;
}

.product-img {
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  object-fit: cover;
}

.name {
  padding-left: 54px;
}

.desktop-one {
  display: none;
}

@media (min-width: 701px) {
  .desktop-one {
    display: block;
  }
}

.mobile-one {
  display: none;
}

@media (max-width: 700px) {
  .mobile-one {
    display: block;
  }
}

.card-title {
  font-weight: 700 !important;
  margin-top: 10px;
}

.col-xl-9, .col-xl-3 {
  padding: 0;
}

.col-xl-3 {
  padding-top: 14px;
}

.sub-col {
  width: 100%;
}
.sub-col:nth-child(2) {
  margin-top: 8px;
  margin-bottom: 8px;
}

@media (min-width: 768px) {
  .sub-col {
    width: calc((100% / 2) - 2px);
  }

  .sub-col:nth-child(2) {
    margin-top: 0;
  }
}

@media (min-width: 1200px) {
  .sub-col {
    width: calc(100% / 3 - 4px);
  }
}

.scroller {
  display: flex;
  height: 100%;
  position: relative;
  flex-wrap: nowrap;
  overflow: auto;
}

.images-wrapper {
  width: 100%;
}

.empty-state-wrapper {
  width: 100%;
}

.card-title {
  padding-bottom: 0px !important;
}

@media (min-width: 1200px) {
  .col-xl-3 {
    padding-top: 0;
    padding-left: 14px;
  }
}

</style>
